import { render, staticRenderFns } from "./AnomaliesReview.vue?vue&type=template&id=ab0336ca&scoped=true"
import script from "./AnomaliesReview.vue?vue&type=script&lang=js"
export * from "./AnomaliesReview.vue?vue&type=script&lang=js"
import style0 from "./AnomaliesReview.vue?vue&type=style&index=0&id=ab0336ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0336ca",
  null
  
)

export default component.exports